import React, { useState, useEffect, useRef, useContext } from "react";
import { NavLink } from "react-router-dom";
import { yourSummary } from "../../configs/routes";
import {
	getIconForCode,
	isOnChartScreen,
} from "../../services/summaryReportsService";

import { codes as defs } from "../../configs/supportedResponseCodes.json";
import {
	isLandscape,
	subscribeToLandscapeChange,
	unsubscribeFromLandscapeChange,
} from "../../services/mobileService";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { LeftScroll, RightScroll } from "../common/ScrollButton";
import { ScrollItem } from "../common/ScrollItem";
import {
	getUserSettings,
	isDemoUser,
	isRegistrar,
} from "../../services/userService";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";
import { CodesToColorMapFunc } from "../../CodesToColorMap";

export const NavBarYourSummary = () => {
	const [hide, setHide] = useState(false);

	const { theme } = useContext(DiseaseGroupContext);

	const isMounted = useRef(false);

	const [userSettings, setUserSettings] = useState(getUserSettings());
	const [isInDemoMode, setIsInDemoMode] = useState(false);
	const [isRegistrarUser, setIsRegistrarUser] = useState(false);

	const handleLandscapeChange = (value) => {
		if (isMounted.current === true) {
			setHide(value && isOnChartScreen());
		}
	};

	useEffect(() => {
		setIsInDemoMode(isDemoUser());
		setIsRegistrarUser(isRegistrar());

		isMounted.current = true;
		const subscriptionName = "NavBarYourSummary";

		subscribeToLandscapeChange(subscriptionName, handleLandscapeChange);

		isLandscape().then(handleLandscapeChange);

		return () => {
			isMounted.current = false;
			unsubscribeFromLandscapeChange(subscriptionName);
		};
	}, []);

	if (hide === true) {
		return null;
	}

	const getPath = (route) => {
		return `${yourSummary}/${route}`;
	};

	const scrollItemMap = (e, index) => {
		const itemTheme = CodesToColorMapFunc(e.code, theme);

		return (
			<ScrollItem key={e.code} itemId={e.code}>
				<NavLink
					to={getPath(e.code)}
					activeClassName={`text-black h-full ${itemTheme.bg()} bg-opacity-30`}
					className={`text-center text-black bg-gray-100 w-16 sm:w-18 md:w-20 lg:w-20 h-5/6 py-1 px-2 text-xxs font-medium flex flex-col leading-none mx-auto`}
				>
					{getIconForCode(e.code, "mx-auto pt-1 text-xl xs:text-xl sm:pb-1.5")}
					{e.title}
				</NavLink>
				<div className={`${itemTheme.bg()} w-full h-1.5 rounded-sm`}></div>
			</ScrollItem>
		);
	};

	let links;

	const registrarOnly = isInDemoMode && isRegistrarUser;

	if (userSettings.yourControl.keepExpensesDiary) {
		links = defs
			.filter((e) => {
				if (!e.registrarOnly) {
					return e;
				} else if (e.registrarOnly && registrarOnly) {
					return e;
				} else {
					return null;
				}
			})
			.map(scrollItemMap);
	} else {
		links = defs
			.filter((e) => {
				if (!e.registrarOnly && e.code !== "cost") {
					return e;
				} else if (e.registrarOnly && registrarOnly) {
					return e;
				} else {
					return null;
				}
			})
			.map(scrollItemMap);
	}

	return (
		<div className={`bg-white z-10 p-4 pb-1 w-full relative`}>
			<ScrollMenu
				scrollContainerClassName={
					"flex justify-between overflow-x-scroll webkit-scrollbar pb-3 h-24 sm:h-28"
				}
				separatorClassName={"m-1"}
			>
				{links}
			</ScrollMenu>
		</div>
	);
};
